import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import { Loader2 } from "lucide-react";

export default function ProtectedRoute({ children, roles, requiredRole }) {
  const { user } = useAuth();
  const location = useLocation();

  if (user === null) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <Loader2 className="w-6 h-6 animate-spin text-muted-foreground" />
      </div>
    );
  }
  
  if (!user) {
    // Redirect to appropriate login based on route
    const isEmployeeRoute = location.pathname.startsWith("/employee");
    return <Navigate to={isEmployeeRoute ? "/employee" : "/login"} state={{ from: location }} replace />;
  }
  
  // Check required role (single role)
  if (requiredRole && user.role !== requiredRole) {
    // Redirect employees to employee portal, staff to staff dashboard
    if (user.role === "employee") {
      return <Navigate to="/employee/workspace" replace />;
    }
    return <Navigate to="/dashboard" replace />;
  }
  
  // Check allowed roles (array)
  if (roles && !roles.includes(user.role)) {
    if (user.role === "employee") {
      return <Navigate to="/employee/workspace" replace />;
    }
    return <Navigate to="/dashboard" replace />;
  }
  
  return children;
}
